import {useApi} from "@/requests/useApi";
import {settings} from "@/settings";
import store from "@/store";
import {deepClone,unmountSelectFieldsV2, headers, Paths, UON,globalConfig, SELECTED_USER_NETWORK} from "@/utils";
import {formatDateLocale} from "@/utils/configuration/formatters-config";
import axios from "axios";
import { getQcOrder } from "../filter/filterService";
import moment from "moment";
import { Picklist, QcHeader, ScaleBuisinessRuleSection } from "@/types";
import { extract, rulePayload, setOrderedRule, setRule } from "@/commons/businessRules";
import { api } from "@/auth/api";
import { getCriteriaList } from "../order/orderService";
import { getPopulationBaseObjective } from "../picklist";
import i18n from "@/i18n";

const api_query_url = settings.api_query_url;
const orchestration = `odm-orchestration`
const orchestrationUrl = `${settings.api_url}/${orchestration}/business-api/1/`

export const BusnissRuleValueKeys: string[] = ["eligibility"];
export const outputFormConfiguration: any = {
  eligibility: ["eligibility"],
};
const buisinessRuleResults = {
  eligibility: true,
};
export const CommisionKeys: string[] = [
  "amount", "formula", "complexResultAmount"
];
export const outputFormCommision: any = {
  
  amount: ["amount", "formula"]
  
};
export const saveOrderPayPlanObjective = async (selectedObjective:any) => {
    const payload = deepClone(selectedObjective)
    
  const primes = selectedObjective.primes
  // Création de l'objet businessData
  const businessData: any = {
    populationField: {
      dbTable: selectedObjective.populationCriteria?.value?.dbTable || "order_order",
      dbField: selectedObjective.populationCriteria?.value?.dbField || "when_created",
    },
    relatedObjectifs: [],
    isIndividualObjective: selectedObjective.isIndividualObjective !== undefined ? selectedObjective.isIndividualObjective : true
  };

  // Regex pour extraire les IDs
  const idPattern = /objectifDetails\['([a-f0-9]+)'\]/g;
  const idsSet = new Set();

  // Parcourir toutes les primes
  primes.forEach((prime:any) => {
    // Chercher dans amount._custom.value
    if (prime.amount) {
      const matches = prime.amount.matchAll(idPattern);
      for (const match of matches) {
        idsSet.add(match[1]);
      }
    }
  });

  // Convertir le Set en tableau
  businessData.relatedObjectifs = Array.from(idsSet);

  console.log(businessData);
  
  
    unmountSelectFieldsV2(payload, [
        "status",
        "frequency",
        "activity"
    ]);
  payload.businessData = businessData;
    payload.frequency=payload.frequency? {resourceUid:payload.frequency} :null
    payload.status=payload.status? {resourceUid:payload.status} :null
    payload.activity=payload.activity? {resourceUid:payload.activity} :null
    payload.startPeriod=  payload.startPeriod ? formatDateLocale(payload.startPeriod, 'DD/MM/YYYY', 'fr'): ''
    payload.endPeriod=  payload.endPeriod ? formatDateLocale(payload.endPeriod, 'DD/MM/YYYY', 'fr'): ''
    payload.displayOrder = payload.displayOrder != null ? Number(payload.displayOrder) : null
      if (payload.eligibility) {
        const rule = setRule(payload.eligibility);
        const orderedRule: { [p: string]: string } = setOrderedRule(
          rule,
          BusnissRuleValueKeys
        );

        payload.eligibility.advancedConfigurationToggle
          ? ((
              store.state.queryBuilderModule.queryBuilder[
                ScaleBuisinessRuleSection.ELIGIBILITY as any
              ] as any
            ).selectedBuisinessRule.returnMultipleResults = true)
          : false;
        payload.eligibility = {
          ruleEngineId: null,
          rule: payload.eligibility.advancedConfigurationToggle
            ? (
                store.state.queryBuilderModule.queryBuilder[
                  ScaleBuisinessRuleSection.ELIGIBILITY as any
                ] as any
              )?.selectedBuisinessRule
            : (
                store.state.queryBuilderModule.queryBuilder[
                  ScaleBuisinessRuleSection.ELIGIBILITY as any
                ] as any
              )?.selectedBuisinessRule
        };
      }
if (!Array.isArray(payload.eligibility)) {
  payload.eligibility = [{ eligibilityValueRule: payload.eligibility,
    basisFlag: true,
    objectType: "odm.order.payplanobjectiveeligibility",
      systemUid: "odm-order",
   }];
}
if (payload.realisation){
  const finalResultExpression = "return " + payload.realisation.expression.replace(
    /param\.(?!QueryInfo)/g,
    'param.QueryInfo.'
  );
  var br= { rule : {
  "label": "RealisationBR",
  "externalId": "businessRuleId",
  "failIfNoResult": false,
  "childInputHeader": [
    {
      "label": payload.realisation?.label || payload.realisation?.criterea?.attribute,
      "dataType": "ARRAY",
      "attribute": "QueryInfo",
      "externalId": "ih-inputHeader1AssessmentKey1-businessRuleId",
      "defaultValue": "",
      "assessmentKey": "inputHeader1AssessmentKey1"
    }
  ],
  "childOutputHeader": [
    {
      "label": "Output Header 1",
      "externalId": "oh-eligibility-businessRuleId",
      "defaultValue": "",
      "businessRuleResultType": "eligibility"
    }
  ],
  "childBusinessRuleItem": [
    {
      "externalId": "bri-1-businessRuleId",
      "evaluationOrder": 1,
      "childBusinessRuleResult": [
        {
          "result": finalResultExpression,
          "externalId": "bris-eligibility-bri-1-businessRuleId",
          "outputHeader": {
            "label": null,
            "externalId": "oh-eligibility-businessRuleId",
            "defaultValue": null,
            "businessRuleResultType": null
          }
        }
      ],
      "childBusinessRuleAssessment": [
        {
          "rule": "return true",
          "externalId": "bria-inputHeader1AssessmentKey1-bri-1-businessRuleId",
          "inputHeader": {
            "label": null,
            "dataType": null,
            "attribute": null,
            "externalId": "ih-inputHeader1AssessmentKey1-businessRuleId",
            "defaultValue": null,
            "assessmentKey": null 
          }
        }
      ]
    }
  ],
  "returnMultipleResults": true
},
ruleEngineId: null
};
const realisationRule = { eligibilityValueRule: br,
    basisFlag: true,
    objectType: "odm.order.payplanobjectiveeligibility",
      systemUid: "odm-order",
   }
payload.eligibility.push(realisationRule)
}
     if (payload.primes) {
         const rule = setRule(payload.primes);
         const orderedRule: { [p: string]: string } = setOrderedRule(
           rule,
           BusnissRuleValueKeys
         );

          ((
              store.state.queryBuilderModule.queryBuilder[
                 ScaleBuisinessRuleSection.PRIMES as any
              ] as any
             ).selectedBuisinessRule.returnMultipleResults = true)
          
         payload.primes = {
           ruleEngineId: null,
           rule: (
               store.state.queryBuilderModule.queryBuilder[
                   ScaleBuisinessRuleSection.PRIMES as any
                 ] as any
               )?.selectedBuisinessRule
           
         };
       }
       // Revert frontend-safe format -> backend format (remove inner quotes)
if (payload.primes.rule?.childBusinessRuleItem?.length) {
  payload.primes.rule.childBusinessRuleItem.forEach((item: any) => {
    if (item?.childBusinessRuleResult?.length) {
      item.childBusinessRuleResult.forEach((resultObj: any) => {
        let res: string | undefined = resultObj?.result?.trim();

        // Match strings like: return '(...)'; 
        const quotedReturnRegex = /^return\s*['"]\(([\s\S]*?)\);['"]\s*$/i;

        if (res && quotedReturnRegex.test(res)) {
          // Extract the expression inside the quotes
          const match = res.match(quotedReturnRegex);
          if (match && match[1] !== undefined) {
            const innerExpr = match[1].trim();
            //  Rebuild correct backend format (no quotes)
            resultObj.result = `return (${innerExpr.replace(
              /param\.(?!QueryInfo)/g,
              "param.QueryInfo."
            )});`;
          }
        }
      });
    }
  });
}

 if (!Array.isArray(payload.primes)) {
  payload.primes = [{ primeValueRule: payload.primes,
    objectType: "odm.order.payplanobjectiveprime",
      systemUid: "odm-order",
   }];
 }
    delete payload.criterea
    payload.realisation = {
      objectType: "odm-configuration.criteriaattribute",
      systemUid: "odm-configuration",
      resourceUid: payload.realisation.id
    }
    delete payload.primesCriteria
    delete payload.basis
    const selectedUserNetwork=localStorage.getItem(SELECTED_USER_NETWORK) || undefined
    payload.networkNode = {
      resourceUid: selectedUserNetwork,
      objectType: "odm.party.networknode",
      systemUid: "odm-party",
    }
    
  delete payload.populationCriteria
  delete payload.isIndividualObjective
    const payPlanObjective =await createOrderPayPlanObjective(payload)
    return payPlanObjective
}



function handleBasisToSave (payload:any){
 const basis= deepClone(payload)
 handleDetailsToSave(basis)
 const basisToSave:any={
  objectType: "odm.order.payplanobjectiveeligibility",
  systemUid: "odm-order",
  targetValue: basis.targetValue,
  targetValueType:basis.targetValueType,
  basisFlag: true,
  criteria: basis.criteria,
  details:basis.details
}
if(basis.resourceUid){
  basisToSave.resourceUid=basis.resourceUid
}
return basisToSave
}

function handleDetailsToSave(payload:any){
  for (const detail of payload.details){
    if(detail.value&& detail.value.type&&detail.value.type.id){
      detail.subCriteria ={
        objectType: "odm.order.subcriteriadefinition",
        systemUid: "odm-order",
        resourceUid: detail.value.type.id
    }
    }
    delete detail.optionsList
    delete detail.value
  }
}
export const handleGetOrderPayPlanObjective = async (resourceUid:any) => {
    const orderPayPlanObjective = await getOrderPayPlanObjective(resourceUid)
        const initSelectedObjectif= store.getters["objectiveModule/initSelectedObjectif"]
        
      if (!orderPayPlanObjective.eligibility) {
      const eligibilityValueRule = {
        advancedConfigurationToggle: true
    }
      initSelectedObjectif.eligibility = eligibilityValueRule
    }

    if (orderPayPlanObjective.eligibility[0]?.eligibilityValueRule) {
      const advancedResult = deepClone(
        orderPayPlanObjective.eligibility[0].eligibilityValueRule.rule?.returnMultipleResults
      );
      if (orderPayPlanObjective.eligibility[0].eligibilityValueRule) {
        (
          store.state.queryBuilderModule.queryBuilder[
            ScaleBuisinessRuleSection.ELIGIBILITY as any
          ] as any
        ).selectedBuisinessRule = orderPayPlanObjective.eligibility[0].eligibilityValueRule.rule;
       
      }
      const extracRule = extract(
        orderPayPlanObjective.eligibility[0].eligibilityValueRule.rule,
        buisinessRuleResults
      );
      store.dispatch("queryBuilderModule/setbrResluts", {
        extracRule: extracRule,
        currentSection: ScaleBuisinessRuleSection.ELIGIBILITY,
      });
      initSelectedObjectif.eligibility = extracRule[0] || {};
      if (extracRule[0] && advancedResult) {
        initSelectedObjectif.eligibility.advancedConfigurationToggle = true;
      } else {
        initSelectedObjectif.eligibility.advancedConfigurationToggle = true;
      }
  }
  


  if (orderPayPlanObjective.businessData && orderPayPlanObjective.businessData.populationField) { 
    const populationFieldRes = await getPopulationBaseObjective();
    console.log('res-----------', populationFieldRes);
    initSelectedObjectif.populationCriteria = populationFieldRes.items.find((item:any) => item.value.dbTable === orderPayPlanObjective.businessData.populationField.dbTable && item.value.dbField === orderPayPlanObjective.businessData.populationField.dbField) || null;
  }
  
  // Set isIndividualObjective: default to true if not present
  initSelectedObjectif.isIndividualObjective = orderPayPlanObjective.businessData && orderPayPlanObjective.businessData.isIndividualObjective !== undefined 
    ? orderPayPlanObjective.businessData.isIndividualObjective 
    : true;
    // const basis=orderPayPlanObjective.eligibility[0]
    // const criterea=orderPayPlanObjective.eligibility.filter((item: any) => item.resourceUid!=basis.resourceUid)
    initSelectedObjectif.resourceUid=orderPayPlanObjective.resourceUid
    initSelectedObjectif.reference=orderPayPlanObjective.reference
    initSelectedObjectif.label=orderPayPlanObjective.label
    initSelectedObjectif.startPeriod=orderPayPlanObjective.startPeriod?orderPayPlanObjective.startPeriod:''
    initSelectedObjectif.endPeriod=orderPayPlanObjective.endPeriod?orderPayPlanObjective.endPeriod:''
    initSelectedObjectif.status=orderPayPlanObjective.status && orderPayPlanObjective.status.resourceUid ?orderPayPlanObjective.status.resourceUid:''
    initSelectedObjectif.frequency=orderPayPlanObjective.frequency&&orderPayPlanObjective.frequency.resourceUid?orderPayPlanObjective.frequency.resourceUid:''
    initSelectedObjectif.activity=orderPayPlanObjective.activity&&orderPayPlanObjective.activity.resourceUid?orderPayPlanObjective.activity.resourceUid:''
    initSelectedObjectif.displayOrder=orderPayPlanObjective.displayOrder != null ? orderPayPlanObjective.displayOrder : null
  
    
  if (orderPayPlanObjective.realisation && orderPayPlanObjective.realisation?.resourceUid){
    const res = await getCriteriaList("criteriaObj");
    const matchedItem = res.find((item:any) => item.id === orderPayPlanObjective.realisation.resourceUid);
    initSelectedObjectif.realisation = matchedItem || null;
  }
    if (!orderPayPlanObjective.primes) {
      const primeValueRule = {
        advancedConfigurationToggle: true
    }
      initSelectedObjectif.primes = primeValueRule
    }

if (orderPayPlanObjective.primes?.length) {
  initSelectedObjectif.primes = [];

  orderPayPlanObjective.primes.forEach((prime:any, index:any) => {
    if (prime?.primeValueRule) {
      const advancedResult = deepClone(
        prime.primeValueRule.rule?.returnMultipleResults
      );
// Normalize result strings: convert unquoted `return (expr);` -> `return '(expr);'`
const rule = prime.primeValueRule.rule;
if (rule?.childBusinessRuleItem?.length) {
  rule.childBusinessRuleItem.forEach((item: any) => {
    if (item?.childBusinessRuleResult?.length) {
      item.childBusinessRuleResult.forEach((resultObj: any) => {
        let res: string | undefined = resultObj?.result?.trim();

        // Detect cases like: return (expression);
        const unquotedReturnRegex = /^return\s*\(/i;
        const quotedReturnRegex = /^return\s*['"]\(/i;

        if (res && unquotedReturnRegex.test(res) && !quotedReturnRegex.test(res)) {
          // Extract inner expression (non-greedy)
          const match = res.match(/^return\s*\(([\s\S]*?)\);\s*$/i);
          if (match && match[1] !== undefined) {
            const innerExpr = match[1].trim();
            //  put the semicolon INSIDE the quotes
            resultObj.result = `return '(${innerExpr});'`;
          }
        }
      });
    }
  });
}



      (
        store.state.queryBuilderModule.queryBuilder[
          ScaleBuisinessRuleSection.PRIMES
        ]
      ).selectedBuisinessRule = prime.primeValueRule.rule;

      const extracRule = extract(prime.primeValueRule.rule, buisinessRuleResults);

      store.dispatch("queryBuilderModule/setbrResluts", {
        extracRule,
        currentSection: ScaleBuisinessRuleSection.PRIMES,
      });

      const primeObj = extracRule[0] || {};

      primeObj.advancedConfigurationToggle = !!(extracRule[0] && advancedResult);

      initSelectedObjectif.primes.push(primeObj);
    } else {
      initSelectedObjectif.primes.push({});
    }
  });
}


    return initSelectedObjectif

}
 async function handledetails(basis:any){
  for(const detail of basis.details){
    detail.value={type: {
      value: detail.subCriteria?detail.subCriteria.resourceUid:'',
      label: detail.subCriteria?detail.subCriteria.resourceUid:''
    }}
    if(detail.criteria&& detail.criteria.resourceUid){
      await store.dispatch("objectiveModule/searchOrderSubCriteriaDefinition", {
       callback: (res: any) => {
         detail.optionsList=res
         },
       filter: {criteria_definition_id:detail.criteria.resourceUid}
     });
   }else{
    detail.criteria={
      objectType: 'odm.order.criteriadefinition',
      systemUid: 'odm-order',
      resourceUid: ''
    }
   }
   detail.optionsList= []

  }

}

//Api's PalyPlan
export const createOrderPayPlan = async (payload: any) => {
    return (await useApi(UON.SystemUid.odmOrder, `${Paths.order.orderPayPlan.create}`).upsert(payload)).response
}

export const getOrderPayPlan = async (resourceUid: any) => {
  return (await useApi(UON.SystemUid.odmOrder, `${Paths.order.orderPayPlan.get(resourceUid)}`).get()).response
}

export const deleteObjective = async (resourceUid: any) => {
  return (await useApi(UON.SystemUid.odmOrder, `payplan`).remove(resourceUid)).response
}


//

//Api's PalyPlanObjective
export const createOrderPayPlanObjective = async (payload: any) => {
  return (await useApi(UON.SystemUid.odmOrder, `${Paths.order.orderPayPlanObjective.create}`).upsert(payload)).response
}
export const getOrderPayPlanObjective = async (resourceUid: any) => {
    return (await useApi(UON.SystemUid.odmOrder, `${Paths.order.orderPayPlanObjective.get(resourceUid)}`).get()).response
}
//
export function searchOrderPayPlanObjective(filter: any,offset?: any, limit?: any, sort?: any): Promise<any[]> {
    return new Promise<any[]>((resolve, reject) => {
        const url = settings.api_query_url;
        const qc= getQcOrderPayPlanObjective(filter,offset,limit,sort)
        const _headers = headers({
            qc: JSON.stringify(qc)
        })
        axios.get(url, {
            headers: _headers
        }).then(res => {
            resolve(res.data)
        }).catch(err => reject(err))
    })
}
// Correspondance entre le nom de colonne de la q-table (objectiveFilterCols)
// et la colonne SQL réelle, pour piloter le tri côté serveur.
const OBJECTIVE_SORT_FIELDS: { [key: string]: string } = {
    display_order: "display_order",
    reference: "_reference",
    name: "label",
    validity_from: "start_period",
    validity_until: "end_period",
    status_code: "status_code",
};
export function getQcOrderPayPlanObjective(filter: any,offset?: any, limit?: any, sort?: any) {
    const qc_header: any = {
      qc: {
        queryId: "order-pay-plan-objective-search",
        offset: offset || 0,
        limit: limit || 100,
      },
    };
  
    qc_header.qc.parameters = {
      ...filter,
    };
    // Tri côté serveur : la liste complète est ordonnée avant pagination, et non plus
    // seulement la page courante affichée par la q-table. Par défaut (aucune colonne
    // sélectionnée par l'utilisateur), on trie sur la référence en ordre ascendant.
    const sortField = (sort && OBJECTIVE_SORT_FIELDS[sort.sortBy]) || "_reference";
    const sortOrientation = (sort && sort.orientation === "DESC") ? "DESC" : "ASC";
    qc_header.qc.otherOrders = {
      fields: [
        {
          table: "order_pay_plan_objective",
          name: sortField,
          orientation: sortOrientation,
        },
      ],
    };
    const operators:any = [];
    if (filter.reference) {
        operators.push(getOperator("lower(order_pay_plan_objective", "_reference)", "LIKE", globalConfig.formatters.getEqualValue(filter.reference + '%').toLowerCase(), ""))
    }
    if (filter.label) {
        operators.push(getOperator("lower(order_pay_plan_objective", "label)", "LIKE", globalConfig.formatters.getEqualValue(filter.label + '%').toLowerCase(), ""))
    }
    if (filter.activity && filter.activity.value) {
        operators.push(
            getOperator(
              "order_pay_plan_objective",
              "activity_code",
              "EQUAL",
              `'${filter.activity.value}'`,
              "activity_code"
            )
          );
    }
    if (filter.status) {
        operators.push(
            getOperator(
              "order_pay_plan_objective",
              "status_code",
              "EQUAL",
              `'${filter.status}'`,
              "status_code"
            )
          );
    }
    if (filter && filter.startPeriod) {
        operators.push(
          getOperator(
            "order_pay_plan_objective",
            "start_period",
            "GREATER_THAN_EQUAL",
            globalConfig.formatters.getEqualValue(moment(filter.startPeriod,  'DD/MM/YYYY').format('YYYY-MM-DD')),
            "startPeriod"
          )
        );
      }
      if (filter && filter.endPeriod) {
        operators.push(
          getOperator(
            "order_pay_plan_objective",
            "end_period",
            "LESS_THAN_EQUAL",
            globalConfig.formatters.getEqualValue(moment(filter.endPeriod,  'DD/MM/YYYY').format('YYYY-MM-DD')),
            "endPeriod"
          )
        );
      }

    
  
    if (operators.length > 0) {
      qc_header.qc.otherFilters = {
        expressions: [
          {
            and: {
              operators,
            },
          },
        ],
      };
    }
    return qc_header.qc;
  }

  export function searchOrderSubCriteriaDefinition(filter: any,offset?: any, limit?: any): Promise<any[]> {
    return new Promise<any[]>((resolve, reject) => {
        const url = settings.api_query_url;
        const qc= getQcOrderSubCriteriaDefinition(filter,offset,limit)
        const _headers = headers({
            qc: JSON.stringify(qc)
        })
        axios.get(url, {
            headers: _headers
        }).then(res => {
            resolve(res.data)
        }).catch(err => reject(err))
    })
}
  export function getQcOrderSubCriteriaDefinition(filter: any,offset?: any, limit?: any) {
    const qc_header: any = {
      qc: {
        queryId: "order-sub-criteria-definition",
        offset: offset || 0,
        limit: limit || 100,
      },
    };
  
    qc_header.qc.parameters = {
      ...filter,
    };
    const operators:any = [];
    if (filter.criteria_definition_id) {
        operators.push(getOperator("order_sub_criteria_definition", "criteria_definition_id", "EQUAL", globalConfig.formatters.getEqualValue(filter.criteria_definition_id), ""))
    }
    
    if (operators.length > 0) {
      qc_header.qc.otherFilters = {
        expressions: [
          {
            and: {
              operators,
            },
          },
        ],
      };
    }
    return qc_header.qc;
  }

   function getOperator(
    table: string,
    field: string,
    operator: string,
    value?: any,
    parameter?: string,
    inParameters?: string[]
  ) {
    return {
      expression: {
        table: table,
        field: field,
        operator: operator,
        value: value,
        parameter: parameter,
        inValue:
          inParameters && inParameters.length > 0
            ? {
                values: inParameters,
              }
            : null,
      },
    };
  }
   function getInOperator(
    table: string,
    field: string,
    operator: string,
    value: any,
    parameter: any,
    inParameters: string
  ) {
    return {
      expression: {
        table: table,
        field: field,
        operator: operator,
        value: value,
        parameter: parameter,
        inValue: {
          values: [inParameters],
        },
      },
    };
  }
export function getQcSearchObjectiveList (filter: any, offset?: any, limit?: any): any {
  const qc_header: QcHeader = {
    qc: {
      queryId: "search-objectiveForBO-list",
      offset: offset || 0,
      limit: limit || 100,
    }

  };

  const operators = []
  if (filter && filter.canal != null &&filter.canal != '') {
            operators.push(
              getOperator("party_network_node","network_id","EQUAL",globalConfig.formatters.getEqualValue(filter.canal),"network_id")
            );
          }
  if (filter && filter.canalNode && filter.canalNode.id) {
              operators.push(
                getOperator("party_network_node","id","EQUAL",globalConfig.formatters.getEqualValue(filter.canalNode.id),"id")
              );
              operators.push(
                getOperator("order_pay_plan","network_nodes","LIKE",globalConfig.formatters.getLikeValue(filter.canalNode.id),"network_nodes")
              );
            }
  if (filter && filter.vendeurList && filter.vendeurList.length>0) {
              let vendeurList=[] 
              for(const vendor of filter.vendeurList){
                  vendeurList.push(vendor.id)
              }
              operators.push(getInOperator("order_pay_plan", "beneficiary_resourceuid", "IN", null, null, globalConfig.formatters.getInValue(vendeurList)))
  
  } else if (filter && filter.vendeurList&& filter.vendeurList.config && filter.vendeurList.config.vendor_id  != null) {
    operators.push(
      getOperator(
        "order_pay_plan", 
        "beneficiary_resourceuid", 
        "EQUAL", 
        globalConfig.formatters.getEqualValue(filter.vendeurList.config.vendor_id),
         "beneficiary_resourceuid"
        )
      )
  }
  if (filter && filter.annee && !filter.periodes) {
 
    const firstDay ='31'
    const month ='12'
    const startDate = `${filter.annee}-${month}-${firstDay}`;
    operators.push(
      getOperator(
        "order_pay_plan",
        "pay_plan_validity_from",
        "LESS_THAN_EQUAL",
        globalConfig.formatters.getEqualValue(startDate),
        "pay_plan_validity_from"
      )
    );
  }
  if (filter && filter.annee && !filter.periodes) {
 
    const lastDay ='01'
    const month ='01'
    const endDate = `${filter.annee}-${month}-${lastDay}`;
    operators.push(
      getOperator(
        "order_pay_plan",
        "pay_plan_validity_until",
        "GREATER_THAN_EQUAL",
        globalConfig.formatters.getEqualValue(endDate),
        "pay_plan_validity_until"
      )
    );
  }
  if (filter && filter.annee && filter.periodes) {
 
    const firstDay ='01'
    const startDate = `${filter.annee}-${filter.periodes.value}-${firstDay}`;
    operators.push(
      getOperator(
        "order_pay_plan",
        "pay_plan_validity_from",
        "LESS_THAN_EQUAL",
        globalConfig.formatters.getEqualValue(startDate),
        "pay_plan_validity_from"
      )
    );
  }
  if (filter && filter.annee && filter.periodes) {
    const year = parseInt(filter.annee, 10);
    const month = parseInt(filter.periodes.value, 10);
    const lastDay = new Date(year, month, 0).getDate();
    const endDate = `${filter.annee}-${filter.periodes.value}-${lastDay}`;
    operators.push(
      getOperator(
        "order_pay_plan",
        "pay_plan_validity_until",
        "GREATER_THAN_EQUAL",
        globalConfig.formatters.getEqualValue(endDate),
        "pay_plan_validity_until"
      )
    );
  }
 if (operators.length > 0) {
    qc_header.qc.otherFilters = {
      expressions: [
        {
          and: {
            operators
          }
        }
      ]
    }

  }

  return qc_header.qc;
}

      export function searchObjectiveList(filter: any, offset?: any, limit?: any): Promise<any[]> {
        return new Promise<any[]>((resolve, reject) => {
          const url = settings.api_query_url;
          const qc = getQcSearchObjectiveList(filter, offset, limit)
          const _headers = headers({
            qc: JSON.stringify(qc)
          })
          axios.get(url, {
            headers: _headers
          }).then(res => {
            resolve(res.data)
          }).catch(err => reject(err))
      })
      }

      export function getPayPlansDetails(filter: any, offset?: any, limit?: any): Promise<any[]> {
        return new Promise<any[]>((resolve, reject) => {
          const url = settings.api_query_url;
          const qc = getQcSearchObjectiveList(filter, offset, limit);
          const _headers = headers({
            qc: JSON.stringify(qc)
          });

          let startDate;
          let endDate;

          if (filter && filter.annee && filter.periodes) {
            const firstDay = '01';
            startDate = `${filter.annee}-${filter.periodes.value}-${firstDay}`;
            const year = parseInt(filter.annee, 10);
            const month = parseInt(filter.periodes.value, 10);
            const lastDay = new Date(year, month, 0).getDate();
            endDate = `${filter.annee}-${filter.periodes.value}-${lastDay}`;
          }
          if (filter && filter.annee && !filter.periodes) {
            const firstDay ='01'
            const month ='01'
            startDate = `${filter.annee}-${month}-${firstDay}`;
            const lastDay ='31'
            const endmonth ='12'
            endDate = `${filter.annee}-${endmonth}-${lastDay}`;
          }
          const body = {
            queryConfiguration: qc,
            startDate,
            endDate
          };

          api()
            .post(`${orchestrationUrl}order/payplan/getPayPlansDetails`, body)
            .then((res: any) => resolve(res))
            .catch((err: any) => reject(err));
        });
      }

export function getQcSearchObjectivePrimeList(filter: any, offset?: any, limit?: any): any {
  const qc_header: QcHeader = {
    qc: {
      queryId: "search-objective-prime-list",
      offset: offset || 0,
      limit: limit || 100,
    }

  };
 //reste a modifier le query "search-objective-prime-list" pour afficher les criteres
  const operators = []
  if (filter && filter.vendeurList&& filter.vendeurList.config && filter.vendeurList.config.vendor_id  != null) {
    operators.push(
      getOperator(
        "order_pay_plan", 
        "beneficiary_resourceuid", 
        "EQUAL", 
        globalConfig.formatters.getEqualValue(filter.vendeurList.config.vendor_id),
         "beneficiary_resourceuid"
        )
      )
  }
  if (filter && filter.annee && !filter.periodes) {
 
    const firstDay ='01'
    const month ='01'
    const startDate = `${filter.annee}-${month}-${firstDay}`;
    operators.push(
      getOperator(
        "order_pay_plan_objective",
        "start_period",
        "GREATER_THAN_EQUAL",
        globalConfig.formatters.getEqualValue(startDate),
        "start_period"
      )
    );
  }
  if (filter && filter.annee && !filter.periodes) {
 
    const lastDay ='31'
    const month ='12'
    const endDate = `${filter.annee}-${month}-${lastDay}`;
    operators.push(
      getOperator(
        "order_pay_plan_objective",
        "end_period",
        "LESS_THAN_EQUAL",
        globalConfig.formatters.getEqualValue(endDate),
        "end_period"
      )
    );
  }
  if (filter && filter.annee && filter.periodes) {
 
    const firstDay ='01'
    const startDate = `${filter.annee}-${filter.periodes.value}-${firstDay}`;
    operators.push(
      getOperator(
        "order_pay_plan_objective",
        "start_period",
        "GREATER_THAN_EQUAL",
        globalConfig.formatters.getEqualValue(startDate),
        "start_period"
      )
    );
  }
  if (filter && filter.annee && filter.periodes) {
    const year = parseInt(filter.annee, 10);
    const month = parseInt(filter.periodes.value, 10);
    const lastDay = new Date(year, month, 0).getDate();
    const endDate = `${filter.annee}-${filter.periodes.value}-${lastDay}`;
    operators.push(
      getOperator(
        "order_pay_plan_objective",
        "end_period",
        "LESS_THAN_EQUAL",
        globalConfig.formatters.getEqualValue(endDate),
        "end_period"
      )
    );
  }
  if (filter && filter.canalNode && filter.canalNode.id) {
    operators.push( getOperator("party_party_role_network","network_node_id","EQUAL",globalConfig.formatters.getEqualValue(filter.canalNode.id),"network_node_id"))
  }
  
  if (operators.length > 0) {
    qc_header.qc.otherFilters = {
      expressions: [
        {
          and: {
            operators
          }
        }
      ]
    }

  }

    return qc_header.qc;
}

      export function searchObjectivePrimeList(filter: any, offset?: any, limit?: any): Promise<any[]> {
        return new Promise<any[]>((resolve, reject) => {
          const url = settings.api_query_url;
          const qc = getQcSearchObjectivePrimeList(filter, offset, limit)
          const _headers = headers({
            qc: JSON.stringify(qc)
          })
          axios.get(url, {
            headers: _headers
          }).then(res => {
            resolve(res.data)
          }).catch(err => reject(err))
      })
      }

/**
 * Process realisation expression to extract the business rule
 * Removes .length, extracts the filter expression
 * Example: param.filter(item=>item.activity===true).length -> param.filter(item=>item.activity===true)
 */
export function processRealisationExpression(expression: string): { isValid: boolean; processedExpression: string; error?: string } {
  if (!expression) {
    return { isValid: false, processedExpression: '', error: String(i18n.global.t("objective.restitution.realisedOrders.errors.expressionUnavailable")) };
  }

  // Check if expression ends with .length
  if (!expression.trim().endsWith('.length')) {
    return { isValid: false, processedExpression: expression, error: String(i18n.global.t("objective.restitution.realisedOrders.errors.notApplicableForRealisationType")) };
  }

  // Remove .length
  const withoutLength = expression.replace(/\.length\s*$/, '').trim();

  return { isValid: true, processedExpression: withoutLength };
}

/**
 * Build the business rule DTO from processed expression
 */
export function buildBusinessRuleFromExpression(expression: string): any {
  // Remove param.QueryInfo.filter or param.filter
  let cleanedExpression = expression
    .replace(/param\.QueryInfo\.filter\s*\(/g, '')
    .replace(/param\.filter\s*\(/g, '');

  // Remove item=> and replace 'item' with JSON.parse(param)
  cleanedExpression = cleanedExpression.replace(/item\s*=>\s*/g, '');
  cleanedExpression = cleanedExpression.replace(/\bitem\b/g, 'JSON.parse(param)');

  // Remove the closing parenthesis if it exists from the filter
  cleanedExpression = cleanedExpression.replace(/\)\s*$/, '');

  const br = {
    rule: {
      label: "Business Rule 1",
      externalId: "businessRuleId",
      failIfNoResult: false,
      childInputHeader: [
        {
          label: "Order Info",
          dataType: "TEXT",
          attribute: "orderInfo",
          externalId: "ih-inputHeader1AssessmentKey1-businessRuleId",
          defaultValue: "",
          assessmentKey: "inputHeader1AssessmentKey1"
        }
      ],
      childOutputHeader: [
        {
          label: "Output Header 1",
          externalId: "oh-eligibility-businessRuleId",
          defaultValue: "",
          businessRuleResultType: "eligibility"
        }
      ],
      childBusinessRuleItem: [
        {
          externalId: "bri-1-businessRuleId",
          evaluationOrder: 1,
          childBusinessRuleResult: [
            {
              result: "return 'true'",
              externalId: "bris-eligibility-bri-1-businessRuleId",
              outputHeader: {
                label: null,
                externalId: "oh-eligibility-businessRuleId",
                defaultValue: null,
                businessRuleResultType: null
              }
            }
          ],
          childBusinessRuleAssessment: [
            {
              rule: `return ${cleanedExpression}`,
              externalId: "bria-inputHeader1AssessmentKey1-bri-1-businessRuleId",
              inputHeader: {
                label: null,
                dataType: null,
                attribute: null,
                externalId: "ih-inputHeader1AssessmentKey1-businessRuleId",
                defaultValue: null,
                assessmentKey: null
              }
            }
          ]
        }
      ],
      returnMultipleResults: true
    },
    ruleEngineId: null
  };

  return br;
}

/**
 * Fetch objective details by ID to get realisation criteria
 */
export async function getObjectiveById(objectiveId: string): Promise<any> {
  return (await useApi(UON.SystemUid.odmOrder, `${Paths.order.orderPayPlanObjective.get(objectiveId)}`).get()).response;
}

/**
 * Fetch criteria attribute details to get the realisation expression
 */
export async function getRealisationCriteriaExpression(criteriaId: string): Promise<any> {
  try {
    const url = settings.api_query_url;
    const qc_header: any = {
      qc: {
        queryId: "realisation-criteria-target",
        offset: 0,
        limit: 1,
      }
    };

    const operators = []
        operators.push(getOperator("configuration_criteria_attribute", "id", "EQUAL", globalConfig.formatters.getEqualValue(criteriaId), ""))
    if (operators.length > 0) {
      qc_header.qc.otherFilters = {
        expressions: [
          {
            and: {
              operators
            }
          }
        ]
      }
      qc_header.qc.otherOrders = null
    }

    const _headers = headers({
      qc: JSON.stringify(qc_header.qc)
    });
    
    const response = await axios.get(url, { headers: _headers });
    return response.data;
  } catch (error) {
    console.error('Error fetching realisation criteria expression:', error);
    throw error;
  }
}

/**
 * Call the API to get realised order references by business rule
 */
export async function getRealisedOrderReferencesByBr(payload: any): Promise<any> {
  try {
    const response = await api().post(`${orchestrationUrl}order/payplan/getRealisedOrderReferencesByBr`, payload);
    return response;
  } catch (error) {
    throw error;
  }
}